import css from "standard/css";

const style = css`
  .video {
    aspect-ratio: 16 / 9;
    max-height: calc(100svh - (120px + 48px + 48px));
    position: relative;
    width: 100%;
  }

  .video iframe {
    height: 100% !important;
    left: 0;
    position: absolute;
    top: 0;
    width: 100% !important;
  }

  .video__cover {
    aspect-ratio: 16 / 9;
    color: transparent;
    max-height: inherit;
    display: block;
    margin: 0 auto;
    background-color: #e6e6e6;
    max-width: 100%;
  }
`;

export default style;
